import React, { Component } from "react";
import { withLanguage } from "../utils/LanguageContext";
import Companies from "../modules/Companies";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import BuyForm from "./BuyForm";
import LanguageSelector from "./LanguageSelector";
import { withRouter } from "../utils/withRouter";

class Restaurant extends Component {
  state = {
    stripePromise: null,
  };

  componentDidMount() {
    const { match } = this.props;

    Companies.getPK(match.params.id)
      .then((stripe_pk) => {
        this.setState({
          stripePromise: loadStripe(stripe_pk),
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    const { stripePromise } = this.state;
    const { currentLanguageCode } = this.props;

    if (!stripePromise) {
      return <div />;
    }

    return (
      <Elements
        stripe={stripePromise}
        options={{ locale: currentLanguageCode }}
      >
        <div className="full-bg">
          <div className="content-wrapper">
            <BuyForm />
          </div>
          <LanguageSelector />
        </div>
      </Elements>
    );
  }
}

export default withRouter(withLanguage(Restaurant));
